export default "__VITE_ASSET__BdtDqBko__"